import { useContext } from "react";
import { ThemeStateContext, ThemeUpdateContext } from "@/contexts/ThemeContext";

// Hook to access the current theme
export const useGetTheme = (): "light" | "dark" | "system" => {
  const context = useContext(ThemeStateContext);
  if (!context)
    throw new Error("useGetTheme must be used within ThemeProvider");
  return context;
};

// Hook to access the theme setter
export const useSetTheme = (): ((
  theme: "light" | "dark" | "system"
) => void) => {
  const context = useContext(ThemeUpdateContext);
  if (!context)
    throw new Error("useSetTheme must be used within ThemeProvider");
  return context;
};
